import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';

export default function ProfileDeletionConfirm() {
  const token = useMemo(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      return (params.get('token') || '').trim();
    } catch {
      return '';
    }
  }, []);

  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState({ ok: false, error: '' });

  useEffect(() => {
    if (!token) setStatus({ ok: false, error: 'Token fehlt.' });
  }, [token]);

  const confirm = async () => {
    if (!token || !checked) return;
    setBusy(true);
    setStatus({ ok: false, error: '' });
    try {
      await api.post('/users/deletion/confirm', { token });
      setStatus({ ok: true, error: '' });
    } catch (e) {
      const msg = e?.response?.data?.error || 'Bestätigung fehlgeschlagen';
      setStatus({ ok: false, error: msg });
    } finally {
      setBusy(false);
    }
  };

  if (status.ok) {
    return (
      <div className="highlight-card" style={{ maxWidth: 720, margin: '40px auto', padding: 24 }}>
        <h2 className="highlight-title" style={{ marginTop: 0 }}>Profil-Löschung bestätigt</h2>
        <p>
          Danke. Dein Account wurde gesperrt und ist zur endgültigen Löschung vorgemerkt.
          Die endgültige Löschung erfolgt anschließend durch einen Admin.
        </p>
        <p>
          Du kannst dieses Fenster schließen oder zur Startseite zurückkehren.
        </p>
        <Link to="/" className="hero-btn-primary" style={{ display: 'inline-block', marginTop: 8 }}>Zur Startseite</Link>
      </div>
    );
  }

  return (
    <div className="highlight-card" style={{ maxWidth: 720, margin: '40px auto', padding: 24 }}>
      <h2 className="highlight-title" style={{ marginTop: 0 }}>Profil-Löschung bestätigen</h2>
      {!token && <p style={{ color: '#ef4444' }}>Token fehlt.</p>}
      {status.error && <p style={{ color: '#ef4444' }}>{status.error}</p>}

      <p style={{ marginTop: 12 }}>
        <strong>Wichtig:</strong> Wenn du fortfährst, werden deine Daten unwiederbringlich gelöscht und du bist kein Mitglied des AP‑Networks mehr.
      </p>
      <p style={{ marginTop: 8, opacity: 0.9 }}>
        Aus rechtlichen/abrechnungstechnischen Gründen können bei kostenpflichtigen Leistungen einzelne Daten (z. B. Rechnungs-/Buchhaltungsdaten) gespeichert bleiben.
      </p>

      <div style={{ marginTop: 14, padding: '10px 12px', border: '1px solid rgba(255,99,71,0.35)', borderRadius: 12, background: 'rgba(255,99,71,0.08)' }}>
        <label style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
          <input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} disabled={busy || !token} />
          <span style={{ fontWeight: 800 }}>Ich möchte die Profil-Löschung endgültig bestätigen.</span>
        </label>
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 16, flexWrap: 'wrap' }}>
        <Link to="/" className="hero-btn-secondary" style={{ display: 'inline-block' }}>Abbrechen</Link>
        <button type="button" className="hero-btn-primary" onClick={confirm} disabled={!token || !checked || busy}>
          {busy ? 'Bestätige…' : 'Jetzt endgültig bestätigen'}
        </button>
      </div>
    </div>
  );
}
